import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Sessione persistente: su 401 rinnova silenziosamente via refresh token e riprova una volta
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    if (error.response?.status === 403 && error.response?.data?.detail?.code === "review_required") {
      window.dispatchEvent(new CustomEvent("arcana-review-required"));
    }
    const skip = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];
    if (error.response?.status !== 401 || original?._retried || skip.some((p) => url.includes(p))) {
      return Promise.reject(error);
    }
    original._retried = true;
    try {
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      await refreshing;
      return api(original);
    } catch {
      return Promise.reject(error);
    }
  }
);

export const mediaUrl = (u) => (u && u.startsWith("/api/") ? process.env.REACT_APP_BACKEND_URL + u : u);

export const fmtErr = (e, fallback = "Qualcosa è andato storto. Riprova.") => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (detail && typeof detail === "object" && !Array.isArray(detail) && detail.message) return detail.message;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return fallback;
};

export const WEEKDAYS = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato", "Domenica"];

export const fmtDate = (iso) => {
  try {
    const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
    return d.toLocaleDateString("it-IT", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  try {
    return new Date(iso).toLocaleString("it-IT", { day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const REVIEW_SERVICES = [
  { v: "sibille", label: "Sibille" },
  { v: "piacentine", label: "Piacentine" },
  { v: "geomanzia", label: "Geomanzia" },
  { v: "rune", label: "Rune" },
  { v: "consulto", label: "Consulto privato con Virginia" },
];

export const reviewServiceLabel = (v) => (REVIEW_SERVICES.find((s) => s.v === v) || {}).label || v;

export const STATUS_LABELS = {
  pending: "In attesa",
  confirmed: "Confermata",
  completed: "Completata",
  cancelled: "Annullata",
};

export const STATUS_COLORS = {
  pending: "bg-amber-500/15 text-amber-400 border-amber-500/40",
  confirmed: "bg-emerald-500/15 text-emerald-400 border-emerald-500/40",
  completed: "bg-violet-500/15 text-violet-300 border-violet-500/40",
  cancelled: "bg-red-500/15 text-red-400 border-red-500/40",
};
